// extracted by mini-css-extract-plugin
module.exports = {"link":"notification_link__ocUOD","message-line-break":"notification_message-line-break__XtFwm"};